import React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { SVGComponentProps } from '../type';

const BootcampHandbookIcon: React.FC<SVGComponentProps> = ({
  width = 16,
  height = 16,
  stroke = '#7F1D1D'
}) => (
  <SVGUniqueID>
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.9987 6.26667C7.9987 4.77319 7.9987 4.02646 8.28935 3.45603C8.54501 2.95426 8.95296 2.54631 9.45472 2.29065C10.0252 2 10.7719 2 12.2654 2H12.532C13.2788 2 13.6521 2 13.9374 2.14532C14.1882 2.27316 14.3922 2.47713 14.52 2.72801C14.6654 3.01323 14.6654 3.3866 14.6654 4.13333V9.86667C14.6654 10.6134 14.6654 10.9868 14.52 11.272C14.3922 11.5229 14.1882 11.7268 13.9374 11.8547C13.6521 12 13.2788 12 12.532 12H11.6155C10.7806 12 10.3632 12 9.98429 12.1151C9.64885 12.2169 9.33679 12.3839 9.06596 12.6065C8.76004 12.858 8.5285 13.2053 8.0654 13.8999L7.9987 14L7.93199 13.8999C7.4689 13.2053 7.23735 12.858 6.93143 12.6065C6.6606 12.3839 6.34854 12.2169 6.0131 12.1151C5.6342 12 5.21677 12 4.38191 12H3.46536C2.71863 12 2.34526 12 2.06004 11.8547C1.80916 11.7268 1.60519 11.5229 1.47736 11.272C1.33203 10.9868 1.33203 10.6134 1.33203 9.86667V4.13333C1.33203 3.3866 1.33203 3.01323 1.47736 2.72801C1.60519 2.47713 1.80916 2.27316 2.06004 2.14532C2.34526 2 2.71863 2 3.46536 2H3.73203C5.2255 2 5.97224 2 6.54267 2.29065C7.04444 2.54631 7.45239 2.95426 7.70805 3.45603C7.9987 4.02646 7.9987 4.77319 7.9987 6.26667ZM7.9987 14V6.26667"
        stroke={stroke}
        strokeWidth={1.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SVGUniqueID>
);

export { BootcampHandbookIcon };
